import {useSequencer} from "components/v2/useSequencer.js";
import {useEffect} from 'react';
//const projectId = 'QmXSTXGeLjKeUBboMqwNj53RTfNyMe23UBof2L2GY6g8pu';
// const projectId = 'QmSKpD9soVrA7vG9x1Ti5ZRXn8nepVcqGi5FZQ3hdkAxmk';
//const projectId = 'QmeciJQyTc897YVz6WGWyCTjR4F71eB8tXhD82KJtqJeh2';
const _kount_projectId = 'QmQ6rkHrGhYqmKtWtoT5MFAnCy4DVwjSNihbVTsRG4nGdp';
// const projectId = 'QmSMGBPaZmmbgi5ze1GwdBiSJN7jQ56sqF5ecHTQJSUMvb';
const projectId = 'QmWfDfsUvn2WBjcd2bFauKNusj59BDW62suKWbjpmYL42a';


export const useLandingSequence = ({store, contextLoaded}) => {
    let [ethereumCache, sequencerEngine, ethereumSearcher] = useSequencer({store}, contextLoaded);

    useEffect(() => {
        if (sequencerEngine) {
            // sequencerEngine.loadSequence(projectId);
        }
    }, [sequencerEngine]);

    return {sequencerEngine};
};
